import React from 'react'
import { connect } from 'react-redux'
import { Entity } from '../app/entity'
import Navigator from '../app/navigator'
import BoxBody from '../helper/boxBody'
import Link from '../helper/link'
import Loading from '../helper/loading'
import { ApplicationState } from '../redux/ApplicationState'
import { MyProfilesEntity } from '../redux/monitor/MonitorState'
import Profile from './profile'

interface OwnProps {
    showTriggerButton: boolean
}

type StateProps = Entity<MyProfilesEntity> & {
    navigator: Navigator
    parameters: any
}
type props = OwnProps & StateProps

class MyProfiles extends React.Component<props> {
    public static defaultProps = {
        showTriggerButton: true,
    }

    public render() {
        if (!this.props.data) {
            return <Loading height={30} title="My Callgraph Traces" />
        }

        return (
            <div className="box">
                <div className="box-header">
                    <nav className="navbar navbar-toolbar">
                        <div className="container-fluid">
                            <h3 className="box-title">My Callgraph Traces</h3>
                            {!this.props.showTriggerButton ? null : (
                                <ul className="nav navbar-nav navbar-right">
                                    <li>
                                        <div className="form-group">
                                            <div className="btn-group" role="group">
                                                <Link route="XhprofProfilerBundle.Profile.list" className="btn btn-default">
                                                    All Traces
                                                </Link>
                                                <Link route="XhprofOrganizationBundle.Application.trigger" className="btn btn-primary">
                                                    Trigger Trace
                                                </Link>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </nav>
                </div>
                <BoxBody {...this.props} className="no-padding">
                    <table className="table table-condensed profile-list">
                        {this.props.data.profiles.profiles && this.props.data.profiles.profiles.length ? (
                            this.props.data.profiles.profiles.map((profile, index) => {
                                return <Profile key={profile.id} rowType={index % 2 ? 'even' : 'odd'} profile={profile} />
                            })
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={8} className="text-center">
                                        You have not triggered any traces in the selected date range.
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </BoxBody>
            </div>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState) => {
    const profiles = globalState.monitor.profiles || new Entity()

    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...profiles,
    }
})(MyProfiles)
